<template>
  <b-modal
    :hide-footer="true"
    :hide-header-close="true"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    :title="$t('Cadastrar Localidade')"
    centered
    id="add-localidade"
    no-fade
  >
    <template v-slot:default>
      <loading-animation
        :active.sync="loading"
        :is-full-page="false"
        :opacity="1"
        color="#3a1143"
      />
      <form @submit.prevent="addLocalidade" ref="addLocalidade">
        <b-form-group class="mb-2" label-for="nome">
          <template v-slot:label
            >{{ $t("Nome") }} <span class="text-danger">*</span></template
          >
          <b-form-input
            id="nome"
            required
            v-model="localidade.nome"
            class="toUpperCase"
          />
        </b-form-group>

        <b-form-group class="mb-2" label-for="zona">
          <template v-slot:label
            >{{ $t("Zona") }} <span class="text-danger">*</span></template
          >
          <b-form-select
            id="zona"
            v-model="localidade.zona"
            :options="options"
          ></b-form-select>
        </b-form-group>
        <div class="float-right mt-3">
          <router-link
            class="btn btn-danger"
            to="/dashboard/enderecos/localidades"
          >
            <i class="mdi mdi-close" />
            {{ $t("Cancelar") }}
          </router-link>
          <button
            class="btn btn-success btn-submit"
            data-style="zoom-in"
            type="submit"
          >
            <i class="mdi mdi-content-save" />
            {{ $t("Salvar") }}
          </button>
        </div>
      </form>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "Add",
  mounted() {
    this.$bvModal.show("add-localidade");
  },
  data() {
    return {
      loading: false,
      localidade: {
        nome: null,
        zona: null,
      },
      options: [
        { value: null, text: "Selecione uma Zona" },
        { value: "URBANA", text: "URBANA" },
        { value: "RURAL", text: "RURAL" },
      ],
    };
  },
  methods: {
    // Add role
    addLocalidade() {
      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();

      // Send request
      axios
        .post("api/dashboard/enderecos/localidades", this.localidade)
        .then((response) => {
          ladda.stop();
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
          this.$router.push("/dashboard/enderecos/localidades");
          this.$parent.getLocalidades();
        });
    },
  },
};
</script>

<style>
.toUpperCase {
  text-transform: uppercase;
}
</style>
